import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { getSubPlan, getSubPlanById } from '../queries/subPlans.query';
@Injectable()
export class SubscriptionPlansService {

  constructor(private http: HttpClient,private apollo: Apollo) { }

  getSubscriptionPlans(){

    return this.apollo.use("external").subscribe({
      query: getSubPlan
      //variables: {id}
    }).pipe(pluck('data', 'subscription_plans'));
  }

  // let headers = {"x-hasura-admin-secret":`${environment.x_hasura_admin_secret}`};

  //   try {
  //     const response = await this.http.get(`${environment.serverBasePath}/api/rest/get-subscription-plans`, { headers : headers }).toPromise();
  //     return response;
  //   } catch (error) {
  //     console.log(error)
  //     throw error;
  //   }

  


  getSubPlanById(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getSubPlanById,
      variables: {id}
    }).pipe(pluck('data', 'subscription_plans_by_pk'));
  }

}
